module.exports = __webpack_public_path__ + "static/media/ipoa2.64a91617.jpg";